import { Months } from 'src/citation-generator/constants';
import { CitationSourceEnum } from 'src/citation-generator/types';
import { EditFormAction, EditFormState, InitializeAction } from './types';
import * as actionNames from './actionsNames';
import { actionToKey, getDefaultContributorState } from './utils';

const initialState: EditFormState = {
  sourceType: CitationSourceEnum.WEBSITE,
  title: '',
  accessDate: undefined,
  publishDate: undefined,
  contributors: [getDefaultContributorState()],
  subTitle: undefined,
  websiteTitle: undefined,
  journalTitle: undefined,
  containerTitle: '',
  collectionTitle: undefined,
  eventTitle: undefined,
  composed: undefined,
  eventDate: undefined,
  edition: undefined,
  volume: undefined,
  issue: undefined,
  series: undefined,
  totalVolumes: undefined,
  citedPages: undefined,
  section: undefined,
  status: undefined,
  number: undefined,
  season: undefined,
  episode: undefined,
  version: undefined,
  medium: undefined,
  publisher: undefined,
  city: undefined,
  state: undefined,
  url: '',
  doi: undefined,
  source: '',

  errors: {},
  warnings: {},

  id: null,
  refId: '',
  isEdit: false,
  resetter: false,
};

export function editFormReducer(state = initialState, action: EditFormAction): EditFormState {
  switch (action.type) {
    case actionNames.SetErrorAndWarning: {
      if (action.payload.error) {
        state.errors[action.payload.key] = action.payload.error;
      } else {
        delete state.errors[action.payload.key];
      }

      if (action.payload.warning) {
        state.warnings[action.payload.key] = action.payload.warning;
      } else {
        delete state.warnings[action.payload.key];
      }

      return {
        ...state,
      };
    }
    case actionNames.Initialize: {
      if ((action as InitializeAction).payload) {
        return {
          ...initialState,
          errors: {},
          warnings: {},
          isEdit: true,
          resetter: !state.resetter,
          id: action.payload!.id || null,
          refId: action.payload!.refId,
          contributors: action.payload!.contributors,
          sourceType: action.payload!.citationSource,
          ...action.payload!.publicationInfo,
        };
      }

      return {
        ...initialState,
        sourceType: CitationSourceEnum.WEBSITE,
        accessDate: {
          day: new Date().getDate(),
          month: Months[new Date().getMonth()],
          year: new Date().getFullYear(),
        },
        contributors: [getDefaultContributorState()],
        errors: {},
        warnings: {},
        resetter: !state.resetter,
      };
    }
    case actionNames.SetSourceType:
      return {
        ...state,
        sourceType: action.payload,
      };
    case actionNames.UpdateContributor:
      if (state.contributors) {
        state.contributors[action.payload.index] = action.payload.value;
        return {
          ...state,
          contributors: [...state.contributors],
        };
      }
      return state;
    case actionNames.SetContributors:
      return {
        ...state,
        contributors: action.payload,
      };
    case actionNames.SetAccessDate:
      return {
        ...state,
        accessDate: action.payload,
      };
    case actionNames.SetPublishDate:
      return {
        ...state,
        publishDate: action.payload,
      };
    case actionNames.ResetState:
      return {
        ...initialState,
        contributors: [],
        errors: {},
        warnings: {},
      };
    default: {
      const key = actionToKey(action.type);
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        return {
          ...state,
          [key]: action.payload,
        };
      }

      return state;
    }
  }
}
